import ConfigData from "../_configPlaync/config";

class DataStore {
    constructor(_config={}){
        this.jsonData = this.getData(this.getApiDomain());
        this.onComplete = _config.onComplete
        return this.jsonData;
    }

    getApiDomain(){
    	let domainHost = window.location.host;
    	let apiDomain;
    	if(domainHost.includes('sb-')){
			apiDomain = 'https://sb-wstatic.plaync.com/'
		}
		else if(domainHost.includes('local')){
			apiDomain = 'https://op-wstatic.ncsoft.com/'
		}
    	else if(domainHost.includes('opdev-')){
			apiDomain = 'https://op-wstatic.ncsoft.com/'
		}
		else if(domainHost.includes('rc-')){
			apiDomain = 'https://rc-wstatic.plaync.co.kr/'
		}
    	else{
			apiDomain = 'https://wstatic-cdn.plaync.com/'
		}
    	return apiDomain;
	}

    getData(_apiDomain){

        let htmlDom = document.getElementsByTagName("html");
        let country =  (htmlDom[0].getAttribute('data-country') === ('NC' || '' || null)) ? 'global' : htmlDom[0].getAttribute('data-country');
        let lang = htmlDom[0].getAttribute('lang');
        let apiDomain = _apiDomain;

		console.log(country);

        let jsonRequest = new XMLHttpRequest();
        if(lang==='zh'){
			jsonRequest.open("GET", apiDomain + "i18n/footer/zh_Hant.json", true);
		}
        // else if(country==='global'){
		// 	jsonRequest.open("GET", apiDomain + "i18n/footer/en.json", true);
		// }
        else{
			jsonRequest.open("GET", apiDomain + "i18n/footer/"+ lang +".json", true);
		}
        jsonRequest.send();

        jsonRequest.onload = ()=>{
            let jsonData = JSON.parse(jsonRequest.responseText);
            let configData = new ConfigData(jsonData, country, lang);

            this.onComplete(configData);
            this.addEvents();
        }
    }
	
	addEvents(){
		let changeListDom = document.getElementsByClassName('footer-change-list');

		document.getElementsByTagName('body')[0].addEventListener('click', (event) =>{
			let containExcept;
			let targetClasslist = event.target.classList;

			for(let i=0; i<targetClasslist.length;i++){
				if(targetClasslist[i] === 'change-item-link' || targetClasslist[i] === 'btn-footer-change' || targetClasslist[i] === 'footer-scroll-wrapper'){
					containExcept = true;
				}
			}
			if(!containExcept){
				for(let i=0; i<changeListDom.length; i++){
					changeListDom[i].classList.remove('on');
				}
			}
		})

		document.querySelector('.footer-change-country .btn-footer-change').addEventListener('click', (event)=> {
			let countryListDom = document.querySelector('.footer-change-country .footer-change-list');
			if(countryListDom.classList.contains('on')){
				for(let i=0; i<changeListDom.length; i++){
					changeListDom[i].classList.remove('on');
				}
				countryListDom.classList.remove('on');
			}
			else{
				for(let i=0; i<changeListDom.length; i++){
					changeListDom[i].classList.remove('on');
				}
				countryListDom.classList.add('on');
			}
		});
		
		document.querySelector('.footer-change-language .btn-footer-change').addEventListener('click', (event)=> {
			let languageListDom = document.querySelector('.footer-change-language .footer-change-list');
			if(languageListDom.classList.contains('on')){
				for(let i=0; i<changeListDom.length; i++){
					changeListDom[i].classList.remove('on');
				}
				languageListDom.classList.remove('on');
			}
			else{
				for(let i=0; i<changeListDom.length; i++){
					changeListDom[i].classList.remove('on');
				}
				languageListDom.classList.add('on');
			}
		});

		document.querySelector('.footer-family-sites .btn-footer-change').addEventListener('click', (event)=> {
			let familySitesListDom = document.querySelector('.footer-family-sites .footer-change-list');
			if(familySitesListDom.classList.contains('on')){
				for(let i=0; i<changeListDom.length; i++){
					changeListDom[i].classList.remove('on');
				}
				familySitesListDom.classList.remove('on');
			}
			else{
				for(let i=0; i<changeListDom.length; i++){
					changeListDom[i].classList.remove('on');
				}
				familySitesListDom.classList.add('on');
			}
		});

		let changeItemLinkDom = document.getElementsByClassName('change-item-link');
		let htmlDom = document.getElementsByTagName("html");
		let country =  (htmlDom[0].getAttribute('data-country') === ('NC' || '' || null)) ? 'global' : htmlDom[0].getAttribute('data-country');
		let lang = htmlDom[0].getAttribute('lang');

		let originPath = window.location.pathname;
		let originSearch = window.location.search;
		let resultPath = '';

		let changeCountry = (_country) => {
			resultPath = '/'+ _country.toLowerCase() + '/';// lw와 다른 부분, 국가 변경시 국가별 메인으로 이동
		}

		let changeLanguage = (_originSearch, _lang, _country) => {
			let locale;
			if(_country === 'global'){
				locale = _lang + '-NC';
			}
			else{
				locale = _lang + '-' + _country;
			}
			let resultSearch = '';
			let originSearchArray =  _originSearch.substring(1, _originSearch.length).split('&');
			let hasLocale = false;

			if(_originSearch === ''){
				resultSearch += 'locale='+ locale;
			}
			else{
				for(let j=0; j<originSearchArray.length; j++){
					if(originSearchArray[j].includes('locale'))	{
						resultSearch += 'locale='+ locale + '&';
						hasLocale = true;
					}
					else{
						resultSearch += originSearchArray[j] + '&';
					}
				}
				if(hasLocale){
					resultSearch = resultSearch.substring(0, resultSearch.length-1);
				}
				else{
					resultSearch += 'locale='+ locale;
				}
			}
			resultPath = originPath + '?' + resultSearch;
		}

		for(let i=0; i<changeItemLinkDom.length; i++){
			changeItemLinkDom[i].addEventListener('click', () => {

				if(changeItemLinkDom[i].getAttribute('data-country') !== null){
					country = changeItemLinkDom[i].getAttribute('data-country');
					changeCountry(country);

					window.location = resultPath;
				}
				else if(changeItemLinkDom[i].getAttribute('data-language') !== null){
					lang = changeItemLinkDom[i].getAttribute('data-language');
					changeLanguage(originSearch, lang, country);

					window.location = resultPath;
				}
			});
		}
	}
} // end of class
export default DataStore;